import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/context/AuthContext";

/**
 * Scrolling flash announcement bar shown on every page load.
 * Pulls the most-popular blend from /api/blends and marquees an announcement.
 */
export default function AnnouncementBar() {
  const [popular, setPopular] = useState(null);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blends?featured=true`).then((r) => {
      const p = (r.data || []).find((b) => b.most_popular);
      if (p) setPopular(p);
    }).catch(() => {});
  }, []);

  if (!visible || !popular) return null;

  const chunk = (
    <>
      <span className="text-[var(--accent)] mx-3 bean-icon">☕</span>
      <span className="text-[var(--text)]">LAUNCH OFFER</span>
      <span className="text-[var(--accent)] mx-3">·</span>
      <span className="font-sacred embossed">5% OFF ALL BLENDS</span>
      <span className="text-[var(--accent)] mx-3">·</span>
      <span className="text-[var(--text-secondary)]">USE CODE</span>
      <span className="text-[var(--primary)] font-mono ml-1">RUDRA5</span>
      <span className="text-[var(--accent)] mx-3 bean-icon">●</span>
      <span
        className="px-3 py-0.5 badge-blink font-sacred"
        style={{
          background: "linear-gradient(90deg, #E5383F, #FF5C5F, #E5383F)",
          color: "#FFFFFF",
          border: "1px solid #7A0F1F",
          letterSpacing: "0.2em",
          fontSize: "10px",
          textShadow: "0 -1px 0 rgba(0,0,0,0.3)",
          boxShadow: "0 2px 6px rgba(0,0,0,0.18)",
        }}
      >
        ★ MOST POPULAR SELLING ★
      </span>
      <span className="text-[var(--accent)] mx-3">·</span>
      <span className="font-sacred embossed">{popular.name.toUpperCase()}</span>
      <span className="text-[var(--accent)] mx-3">·</span>
      <span className="text-[var(--ember)]">₹{popular.price_inr} / 250G</span>
      <span className="text-[var(--accent)] mx-3">·</span>
      <Link to={`/shop/${popular.id}`} className="text-[var(--primary-hover)] link-underline">SHOP NOW →</Link>
      <span className="text-[var(--accent)] mx-3 bean-icon">☕</span>
    </>
  );

  return (
    <div
      className="fixed top-[72px] left-0 right-0 z-40 overflow-hidden border-b announce-flash"
      data-testid="announcement-bar"
      style={{ borderColor: "var(--border-strong)" }}
    >
      <button
        onClick={() => setVisible(false)}
        aria-label="Dismiss announcement"
        className="absolute right-3 top-1/2 -translate-y-1/2 z-10 text-[var(--text-muted)] hover:text-[var(--text)] text-xs font-mono px-2"
        data-testid="announce-close"
      >
        ✕
      </button>
      <div className="marquee-track">
        <div className="marquee-content font-mono text-[11px] tracking-[0.25em] uppercase py-2.5 whitespace-nowrap">
          {["m1", "m2", "m3"].map((k) => (
            <React.Fragment key={k}>{chunk}</React.Fragment>
          ))}
        </div>
        <div className="marquee-content font-mono text-[11px] tracking-[0.25em] uppercase py-2.5 whitespace-nowrap" aria-hidden>
          {["m1b", "m2b", "m3b"].map((k) => (
            <React.Fragment key={k}>{chunk}</React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
